export const SEND_SUCCESS_SNACK = 'send-snackbar:success';
export const SEND_ERROR_SNACK = 'send-snackbar:error';
export const SNACKBAR_TIMEOUT = 300;
